import { formatHumansBs } from "../../helpers/formatHuman";
import React from 'react'
import { getImage } from "../../helpers";
import { useState } from "react";
import { useEffect } from "react";

const CartItem = ({ item, eliminarItem, actualizarCantidad }) => {

    const [cantidadProduct, setCantidadProduct] = useState( item.cantidad );

    const onValueChanged = (value) => {
        let newCantidad = cantidadProduct + value;
        if ( newCantidad < 1) return;
        setCantidadProduct(newCantidad);
        actualizarCantidad( item, newCantidad );
    };
    

    return (
        <div className="relative">
            <div className="border-2 flex items-center rounded-2xl p-3 gap-3">
                <img
                    src={getImage(item.imagen)}
                    alt="Propiedad imagen"
                    className="object-cover h-auto w-20"
                />
                <div className="flex-1 flex flex-col gap-2">
                    <h2 className="text-sm w-full text-gray-800 font-bold">
                        {item.nombrep}
                    </h2>
                    <p className="text-gray-600">
                        {formatHumansBs(item.precio)}
                    </p>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <span className="rounded-full cursor-pointer font-bold py-1 px-4 bg-gray-200" onClick={ () => onValueChanged(+1) }>
                                +
                            </span>
                            <span>{cantidadProduct}</span>
                            <span className="rounded-full cursor-pointer font-bold py-1 px-4 bg-gray-400" onClick={ () => onValueChanged(-1)}>
                                -
                            </span>
                        </div>
                        <span className="cursor-pointer text-red-600" onClick={ () => eliminarItem(item.idprod) }>
                            <i className="fas fa-trash"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartItem;
